module.exports = __webpack_public_path__ + "img/submit-button.ece28235.png";